/* eslint-disable no-shadow */
export enum URL {
  GET_WAITING_ROOM_BY_UID = 'get-waiting-room-by-guid',
  GET_MAIN_CALL_JOIN_INFO = 'v2/general/get-main-call-joining-info',
  GET_READINESS_CALL_JOIN_INFO = 'v2/general/get-tech-readiness-call-joining-info',
}
